export const DOCUMENTS = {
  GUARANTEE: 'guarantee',
  PRESENTATION: 'presentation',
  REPORT: 'report',
  SGR: 'sgr',
  SGR_EGOV: 'sgr-egov',
  STATUTE: 'statute',
  VAT: 'vat',
};
